import * as THREE from 'three';
import { WebGLElement } from './base.js';

// <skill-box text="Go" position="0 6 0"> — a labelled box mesh (canvas-texture
// chip, sized to the text). A WebGLElement, so it parents into the nearest
// <three-scene>; wrap it in <physics-body> to make it fall.
const INK = '#1a1b26'; // dark text — chip is filled with the category color
const ACCENTS = ['#7aa2f7', '#bb9af7', '#7dcfff', '#9ece6a', '#e0af68', '#ff9e64', '#f7768e'];
let counter = 0;

function labelTexture(text, accent) {
  const fs = 52;
  const pad = 30;
  const dpr = 2;
  const c = document.createElement('canvas');
  const ctx = c.getContext('2d');
  ctx.font = `600 ${fs}px "Fira Code", monospace`;
  const tw = ctx.measureText(text).width;
  const w = Math.ceil(tw + pad * 2);
  const h = fs + pad * 2;
  c.width = w * dpr;
  c.height = h * dpr;
  ctx.scale(dpr, dpr);
  ctx.fillStyle = accent;
  ctx.fillRect(0, 0, w, h);
  ctx.fillStyle = INK;
  ctx.font = `600 ${fs}px "Fira Code", monospace`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, w / 2, h / 2 + 2);
  const tex = new THREE.CanvasTexture(c);
  tex.anisotropy = 8;
  tex.needsUpdate = true;
  return { tex, aspect: w / h };
}

export class SkillBox extends WebGLElement {
  static properties = {
    ...WebGLElement.properties,
    label: { type: String },
    accent: { type: String },
    depth: { type: Number },
  };

  constructor() {
    super();
    this.label = '';
    this.accent = '';
    this.depth = 0.32;
  }

  createObject3D() {
    const accent = this.accent || ACCENTS[counter++ % ACCENTS.length];
    const { tex, aspect } = labelTexture(this.label || '?', accent);
    const bh = 0.42;
    const hw = Math.max(0.55, bh * aspect);
    const label = new THREE.MeshStandardMaterial({ map: tex, roughness: 0.55, metalness: 0.05 });
    const edge = new THREE.MeshStandardMaterial({ color: accent, roughness: 0.55, metalness: 0.05 });
    // BoxGeometry face order [+x,-x,+y,-y,+z,-z]: text only on the two large z-faces; edges solid accent
    const mats = [edge, edge, edge, edge, label, label];
    return new THREE.Mesh(new THREE.BoxGeometry(hw * 2, bh * 2, this.depth * 2), mats);
  }
}

customElements.define('skill-box', SkillBox);
